var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-suggestions-row",
      style: { background: _vm.colors.messageList.bg },
    },
    _vm._l(_vm.suggestions, function (suggestion, idx) {
      return _c(
        "button",
        {
          key: idx,
          staticClass: "sc-suggestions-element",
          style: {
            borderColor: _vm.colors.sentMessage.bg,
            color: _vm.colors.sentMessage.bg,
          },
          on: {
            click: function ($event) {
              return _vm.$emit("sendSuggestion", suggestion)
            },
          },
        },
        [_vm._v("\n        " + _vm._s(suggestion) + "\n    ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }